export default class formConfig {
  // 中标基本信息
  static projectInformation() {
    return [
      {
        title: "中标项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标项目名称：",
            value: "prjName",
            type: "slot",
            slotName: "prjName",
            tip: "需录入开标记录后才能在此选择到项目。",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "公示开始时间：",
            value: "publicityStartDate",
            type: "input",
            disabled: true,
          },
          {
            label: "公示结束时间：",
            value: "publicityEndDate",
            type: "input",
            disabled: true,
          },
          {
            label: "公示天数（天）：",
            value: "publicityDay",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 10,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                message: "请输入数字"
              }
            ]
          },
          {
            label: "招标监管部门：",
            value: "regulators",
            type: "input",
            disabled: true,
          },
          {
            label: "开标时间：",
            value: "reserveStartTime",
            type: "date",
            dateType: "datetime",
            disabled: false,
            required: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "开标地点：",
            value: "openingPlace",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 70,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            label: "评标时间：",
            value: "evaluationStartDate",
            type: "date",
            dateType: "datetime",
            disabled: false,
            required: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "评标地点：",
            value: "reviewAdd",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 70,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            label: "招标编号：",
            value: "tenderReference",
            type: "input",
            disabled: true,
          },
          {
            label: "标段号：",
            value: "section",
            type: "input",
            disabled: true,
          },
          {
            label: "建设单位（招标人）：",
            value: "tenderCorp",
            type: "input",
            maxlength: 80,
            disabled: true,
          },
          {
            label: "经办人：",
            value: "person",
            type: "input",
            maxlength: 80,
            disabled: false
          },
          {
            label: "联系电话：",
            value: "personPhone",
            type: "input",
            disabled: false,
            required: false,
            maxlength: 11,
            rule: [
              {
                required: false,
                message: "请输入联系电话",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message:
                  "输入的手机号码不正确！",
              },
            ]
          },
          {
            label: "招标代理机构：",
            value: "agencyCorp",
            type: "input",
            maxlength: 80,
            disabled: true,
          },
          {
            label: "经办人：",
            value: "agencyCorpPerson",
            type: "input",
            maxlength: 80,
            disabled: false
          },
          {
            label: "联系电话：",
            value: "agencyCorpPhone",
            type: "input",
            maxlength: 11,
            disabled: false,
            required: false,
            rule: [
              {
                required: false,
                message: "请输入联系电话",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message:
                  "输入的手机号码不正确！",
              },
            ]
          },
          {
            label: "项目名称：",
            value: "constructionPrjName",
            type: "input",
            disabled: true,
          },
          {
            label: "项目编号：",
            value: "constructionNo",
            type: "input",
            disabled: true,
          },
          {
            label: "招标方式：",
            value: "tenderTypeName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标类别：",
            value: "tenderClassName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标内容：",
            value: "tenderContent",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门名称：",
            value: "dissentDepartmentName",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门地址：",
            value: "dissentDepartmentAddress",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门联系人：",
            value: "dissentDepartmentLinkMan",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门联系人手机：",
            value: "dissentDepartmentLink",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门邮政编码：",
            value: "dissentPostalCode",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门电子邮箱：",
            value: "dissentDepartmentEmail",
            type: "input",
            disabled: true,
          },
          {
            label: "行政监督部门名称：",
            value: "supervisionDept",
            type: "input",
            maxlength: 100,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "行政监督部门地址：",
            value: "supervisionDeptAddress",
            type: "input",
            maxlength: 100,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "行政监督部门联系人：",
            value: "supervisionDeptLinkMan",
            type: "input",
            maxlength: 40,
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "行政监督部门电话：",
            value: "supervisionDeptLinkPhone",
            type: "input",
            maxlength: 12,
            disabled: false,
            required: true,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                message: "输入的部门电话不正确！",
              },
            ]
          },
          {
            label: "公共资源交易综合监管机构名称：",
            value: "tradingCenter",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "公共资源交易综合监管机构地址：",
            value: "tradingCenterAddress",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 100,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "公共资源交易综合监管机构联系人：",
            value: "tradingCenterLinkMan",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 40,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "公共资源交易综合监管机构电话：",
            value: "tradingCenterLinkPhone",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 12,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/,
                message: "输入的部门电话不正确！",
              },
            ]
          },
          {
            label: "房屋建筑工程面积：",
            value: "structureArea",
            type: "input",
            disabled: false,
            maxlength: 100,
          },
          {
            label: "结构层次：",
            value: "highFloor",
            type: "input",
            disabled: false,
            maxlength: 80,
          },
          {
            label: "地上：",
            value: "upFloor",
            type: "input",
            disabled: false,
            maxlength: 10,
          },
          {
            label: "地下：",
            value: "underFloor",
            type: "input",
            disabled: false,
            maxlength: 10,
          },
          {
            label: "建设地址：",
            value: "prjAddress",
            type: "input",
            maxlength: 80,
            disabled: false
          },
          {
            label: "建设规模：",
            value: "prjSize",
            type: "textarea",
            disabled: false,
            maxlength: 800,
            width: "100%;"
          },
          {
            label: "招标范围：",
            value: "tenderScope",
            type: "slot",
            slotName: "tenderScope",
            tip: "默认显示登记中招标内容说明，若需修改信息则还需填写修改原因。",
          },
          {
            label: "招标范围修改原因：",
            value: "tenderScopeUpdate",
            type: "slot",
            slotName: "tenderScopeUpdate",
            maxlength: 800,
          },
          {
            label: "备注(注明单体工程名称、栋号)：",
            value: "remarksMonomer",
            type: "textarea",
            disabled: false,
            maxlength: 800,
            width: "100%;"
          },
          {
            label: "公示状态：",
            type: "slot",
            slotName: "publicState",
            value: "publicState",
            required: true,
            tip: "中标通知书发出前，可进行撤回操作，撤回后，可以重新发布中标公示。",
            rule: {
              required: true,
              message: "请选择公示状态",
              trigger: "change"
            },
          },
          {
            label: "是否需要项目负责人/总监：",
            value: "isNeedPmName",
            type: "input",
            disabled: true,
          },
          {
            label: "公示发布责任人：",
            value: "bulletinDuty",
            type: "input",
            disabled: false,
            required: true,
            maxlength: 40,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            label: "是否有履约保证金：",
            value: "isPerformanceBondAmount",
            type: "select",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202304141126290004"
            },
          },
          {
            label: "履约保证金（元）：",
            value: "performanceBondAmount",
            type: "input",
            disabled: true,
            maxlength: 38,
            rule: [
              {
                required: false,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                message: "请输入数字"
              }
            ]
          },
          {
            label: "是否有工程质量保证金：",
            value: "isProjectQualityDeposit",
            type: "select",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202304141128410007"
            },
          },
          {
            label: "工程质量保证金（元）：",
            value: "projectQualityDeposit",
            type: "input",
            disabled: true,
            maxlength: 38,
            rule: [
              {
                required: false,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                message: "请输入数字"
              }
            ]
          },
        ]
      },
      {
        title: "撤回",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "附件上传：",
            type: "slot",
            class: "revocationFile",
            slotName: "revocationFile",
          },
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "revocationData",
          },
        ]
      },
    ];
  }
  // 中标候选人信息
  static winBidInformation() {
    return [
      {
        title: "中标候选人信息",
        tip: "（前三名）",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "listData",
          },
        ]
      },
      {
        title: "退还招标单位保证金信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "refundData",
          },
          {
            label: "文件上传：",
            type: "slot",
            slotName: "refundFile",
            tipContent: "请上传jpg，gif或png格式的图片",
            width: "100%;"
          },
        ]
      },
      {
        title: "不退还申请表",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "pictureData",
          },
        ]
      },
    ];
  }
  // 开标记录信息
  static bidOpeningRecordInformation() {
    return [
      {
        title: "开标记录信息",
        name: "1",
        icon: "",
        class: "bidOpeningRecord",
        formConfigList: [
          {
            label: "公开类型：",
            value: "openType",
            type: "input",
            disabled: true,
          },
          {
            label: "开标地点：",
            value: "bidOpeningAddress",
            type: "input",
            disabled: true,
          },
          {
            label: "开标时间：",
            value: "bidOpeningTime",
            type: "input",
            disabled: true,
          },
          {
            label: "开标参与人：",
            value: "bidOpeningActor",
            type: "textarea",
            disabled: true,
            width: "100%;"
          },
        ]
      },
      {
        title: "开标内容",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "bidOpeningContent",
          },
        ]
      },
      {
        title: "第二信封开标记录信息",
        name: "3",
        icon: "",
        class: "doubleBidOpeningRecord",
        formConfigList: [
          {
            label: "公开类型：",
            value: "doubleOpenType",
            type: "input",
            disabled: true,
          },
          {
            label: "开标地点：",
            value: "doubleBidOpeningAddress",
            type: "input",
            disabled: true,
          },
          {
            label: "开标时间：",
            value: "doubleBidOpeningTime",
            type: "input",
            disabled: true,
          },
          {
            label: "开标参与人：",
            value: "doubleBidOpeningActor",
            type: "textarea",
            disabled: true,
            width: "100%;"
          },
        ]
      },
      {
        title: "第二信封开标内容",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "list",
            slotName: "doubleBidOpeningContent",
          },
        ]
      },
    ];
  }
  // 其他信息
  static otherInformation() {
    return [
      
      {
        title: "备注",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            maxlength: 800,
            tip: "（1250字以内）",
            disabled: false,
            width: "100%;"
          },
        ]
      },
      {
        title: "核验意见",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "历史核验记录：",
            type: "slot",
            slotName: "auditBtn",
          },
        ]
      },
      {
        title: "变更公告记录",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "历史记录：",
            type: "slot",
            slotName: "hisBtn",
          },
        ]
      },
      {
        title: "招标人意见",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "招标人意见：",
            type: "slot",
            slotName: "tenderOpinion",
            width: "100%;"
          },
        ]
      },
    ];
  }
}
